import { useState, useEffect, useCallback } from "react";
import type { HubSpotField } from "../types/configurator";
import { fetchFields } from "../api/hubspot";

export function useHubSpotFields() {
  const [fields, setFields] = useState<HubSpotField[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadFields = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchFields();
      setFields(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load fields');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFields();
  }, [loadFields]);

  return { fields, loading, error, refetch: loadFields };
}
